module.exports = __webpack_public_path__ + "img/camping.bccd294d.jpg";